if (!customElements.get("td-product-customization")) {
    class TDProductCustomization extends HTMLElement {
        constructor() {
            super();
            this.ACTIVE_CLASS = '.td-selected-option'
            this.SOLDOUT_CLASS = 'soldout'

            this.activeText = this.querySelector(this.ACTIVE_CLASS)
            this.options = this.querySelectorAll('li')
            this.activeOption = null
        }
    
        connectedCallback() {
            if (this.options.length > 0) {
                this.options.forEach((option) => {
                    option.addEventListener('click', () => {
                        let value = option.querySelector('input').value
                        let disabled = option.querySelector('input').disabled
                        let isDisabled = option.classList.contains(this.SOLDOUT_CLASS)

                        if (this.activeOption != value) {
                            if (!disabled) {
                                if (!isDisabled) {
                                    this.activeOption = value
                                    // if (this.activeText) {
                                    //     this.activeText.textContent = ' ' + this.activeOption
                                    // }
                                }
                            }
                        }
                    })
                })
            }
        }
    }

    customElements.define("td-product-customization", TDProductCustomization);
}